import { useState, useRef, useEffect } from "react";
import { C } from "../../lib/constants";

const _toastPendingQueue = [];
if (typeof window !== "undefined" && !window.ficioToast) {
  window.ficioToast = (msg, type="info", duration=3500) => _toastPendingQueue.push({msg,type,duration});
}

export const FicioToast = () => {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);
  useEffect(() => {
    const show = (msg, type="info", duration=3500) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      setToast({msg, type});
      timerRef.current = setTimeout(() => setToast(null), duration);
    };
    window.ficioToast = show;
    if (_toastPendingQueue.length) {
      const {msg, type, duration} = _toastPendingQueue[_toastPendingQueue.length - 1];
      _toastPendingQueue.length = 0;
      show(msg, type, duration);
    }
    return () => { window.ficioToast = null; };
  }, []);
  if (!toast) return null;
  const colors = {
    error:   {bg:C.redL,   border:C.red,   text:C.red,   icon:"⚠️"},
    success: {bg:C.greenL, border:C.green, text:C.green, icon:"✅"},
    info:    {bg:C.blueL,  border:C.blue,  text:C.blue,  icon:"ℹ️"},
    warn:    {bg:C.accentL,border:C.accent,text:C.accent,icon:"⚡"},
  };
  const s = colors[toast.type] || colors.info;
  return (
    <div style={{position:"fixed",top:20,left:"50%",transform:"translateX(-50%)",
      zIndex:9999,maxWidth:360,width:"90%",
      background:s.bg,border:`1.5px solid ${s.border}40`,
      borderRadius:14,padding:"14px 18px",
      boxShadow:"0 8px 32px rgba(0,0,0,0.15)",
      display:"flex",gap:10,alignItems:"center",
      animation:"slideDown 0.2s ease"}}>
      <span style={{fontSize:18,flexShrink:0}}>{s.icon}</span>
      <span style={{color:s.text,fontSize:13,fontWeight:600,lineHeight:1.4}}>{toast.msg}</span>
    </div>
  );
};
